export const moduleConfig = {
    entityKey: 'metering-records',
    titles: {
        singular: 'Metering Record',
        plural: 'Metering Records'
    }
}

export const initialSortState = {
    column: 'created',
    direction: 'desc',
};
